import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-647a0822"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "btn btn-sm btn-outline-secondary photo-upload-button" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))

import _ from 'lodash';
import { ref, computed, PropType, inject } from 'vue';
import LogoComponent from '@/components/logo/Logo.vue';
import { useStore } from 'vuex';
import { Photo } from '@/models';
import { useToast } from "vue-toastification";
import sanitize from "sanitize-filename";
import slugify from "slugify";
import moment from "moment-timezone";
import { Storage } from 'aws-amplify';


export default /*#__PURE__*/_defineComponent({
  __name: 'Logos',
  props: {
  path: { type: String as PropType<string>, default: ''},
  photos: { type: Object as PropType<Photo[]>, default: []},
  buttontext: {type: String as PropType<string>, required: false},
  target: { type: String as PropType<string>, default: ''},
},
  emits: ['documentadded', 'documentdeleted'],
  setup(__props, { emit: __emit }) {

const jo = require("jpeg-autorotate");
const piexif = require("piexifjs");
const props = __props;

const { path, photos, buttontext, target } = props;

const store = useStore();

const customerdictionary = computed(() => store.getters['customerdictionary/current']);
const inspector = computed(() => store.getters['inspectors/current']);
const deviceKey = computed(() => store.getters['auth/deviceKey']);

const setCustomerDictionaryDeep = (payload: {
    path: string;
    data: any;
  }): Promise<any> =>
  store.dispatch('customerdictionary/setCustomerDictionaryDeep', payload);

const setInspectorDeep = (payload: {
    path: string;
    data: any;
  }): Promise<any> =>
  store.dispatch('inspectors/setInspectorDeep', payload);

const actProperty: any = inject('actProperty');
const toasted = useToast();
const file = ref(null);

const emit = __emit

const isDragging = ref(false);
const uploadingCount = ref(0);

const galleryType = (): string => {
  if (path.endsWith("photos.in")) {
    return path.endsWith("photos.in") ? "in" : "out";
  }
  return path.endsWith("condition.in.photos") ? "in" : "out";
}

// Computed properties
const _photos = computed(() => photos);

// Methods converted to the Composition API style
const onDragOver = (event: DragEvent) => {
  isDragging.value = true;
};

const onDragLeave = (event: MouseEvent) => {
  if (event.currentTarget === event.target) {
    isDragging.value = false;
  }
};

const onDrop = (event: DragEvent) => {
  isDragging.value = false;
  const files: FileList | null = _.get(event, "dataTransfer.files", null);
  uploadFiles(files);
};


const onFileInputChange = (event: Event) => {
  const files = _.get(file.value, "files", null);
  uploadFiles(files);
};

const uploadFiles = async (files: FileList | null) => {
  try {
      if (null === files || 0 === files.length) {
        return;
      }

      uploadingCount.value = 0;

      // S3 options
      const options: any = {
        contentType: "image/jpeg",
        customPrefix: {
          public: "",
          protected: "",
          private: "",
        },
        level: "public",
      };
     
      for (let i = 0; i < files.length; i++) {
        let file: File | null = files.item(i);

        if (file === null) {
          continue;
        }

        const { name, type, lastModified } = file;

        if (type !== "image/jpeg") {
          actProperty.displayError(`${sanitize(name)} is not a JPEG.`);
          continue;
        }

        // Increase uploadingCount (displays loading spinner)
        ++uploadingCount.value;

        // Use ArrayBuffer for jpeg-autorotate
        const arrayBuffer = await file.arrayBuffer();

        let imageBuffer = new Buffer(arrayBuffer);

        // Prevent "Given thumbnail is too large. max 64kB" error
        imageBuffer = deleteThumbnailFromExif(imageBuffer);

        // Correct the orientation using jpeg-autorotate
        await jo
          .rotate(imageBuffer, {})
          .then(
            (result: {
              buffer: any;
              orientation: number;
              dimensions: {
                width: number;
                height: number;
              };
              quality: number;
            }) => {
              // console.log(`Orientation was ${result.orientation}`)
              // console.log(`Dimensions after rotation: ${result.dimensions.width}x${result.dimensions.height}`);
              // console.log(`Quality: ${result.quality}`);

              /**
               * The 8 EXIF orientation values are numbered 1 to 8:
               *
               * 1 = 0 degrees: the correct orientation, no adjustment is required.
               * 2 = 0 degrees, mirrored: image has been flipped back-to-front.
               * 3 = 180 degrees: image is upside down.
               * 4 = 180 degrees, mirrored: image has been flipped back-to-front and is upside down.
               * 5 = 90 degrees: image has been flipped back-to-front and is on its side.
               * 6 = 90 degrees, mirrored: image is on its side.
               * 7 = 270 degrees: image has been flipped back-to-front and is on its far side.
               * 8 = 270 degrees, mirrored: image is on its far side.
               */
              if (result.orientation > 1) {
                // Recreate File from jpeg-autorotate Buffer data
                const newFileBuffer = Buffer.from(result.buffer);

                // Update the File we will send to S3
                file = new File([newFileBuffer], name, {
                  type: type,
                  lastModified: lastModified,
                });
              }
            }
          )
          .catch((error: any) => {
            switch (error.code) {
              // Some errors should not halt processing
              case jo.errors.read_exif: // EXIF data could not be read
              case jo.errors.no_orientation: // No orientation tag was found
              case jo.errors.correct_orientation: // The image orientation is already correct
                console.info(name, error.message, error);
                break;
              // Rethrow all other errors
              case jo.errors.read_file: // File could not be opened
              case jo.errors.unknown_orientation: // The orientation tag is unknown
              case jo.errors.rotate_file: // An error occurred when rotating the image
              default:
                throw error;
            }
          });

        // Add timestamp to make each device upload unique, and sanitise input filename
        let deviceKeyPrefix = `${deviceKey.value}`;
        if (!deviceKey.value) deviceKeyPrefix = `tenantcomments`;
        else deviceKeyPrefix = `${deviceKey.value}`;
        const s3Filepath = `${deviceKeyPrefix}/${moment().format(
          "x"
        )}/${slugify(sanitize(name))}`;

        // Save the File to S3
        await Storage.put(s3Filepath, file, options)
          .then(({ key }: any) => {
            if (!key || !key.length) {
              --uploadingCount.value;
              throw Error("Could not determine uploaded URL");
            }

            // Create the Photo from the S3 response
            const photo = new Photo({
              src: actProperty.s3Origin(key),
              createdAt: actProperty.datetimeToUTC(lastModified),
              // We only display the link to the Gallery when the parent Report has been saved
              hasGalleryLink: false,
            });

            // Add Photo to photos array
            if (target === "customerdictionary") {
              const photos = _.get(customerdictionary.value, path).concat([
                photo,
              ]);

              // Update Vuex
              setCustomerDictionaryDeep({ path: path, data: photos });
            } else if (target === "inspector") {
              const photos = _.get(inspector.value, path).concat([photo]);

              // Update Vuex
              setInspectorDeep({ path: path, data: photos });
            }

            --uploadingCount.value;
          })
          .catch((error: Error) => {
            // Adjust uploadingCount and rethrow error
            --uploadingCount.value;
            throw error;
          });
      }
    } catch (error) {
      actProperty.displayError(error);
    }
}

/**
 * Remove the thumbnail from an image.
 *
 * This prevents the "Given thumbnail is too large. max 64kB" error.
 *
 * @link https://github.com/johansatge/jpeg-autorotate#thumbnail-too-large
 *
 * @param {Buffer} imageBuffer Image Buffer
 *
 * @returns {Buffer}
 */
const deleteThumbnailFromExif = (imageBuffer: Buffer) => {
  const imageString = imageBuffer.toString("binary");
  const exifObj = piexif.load(imageString);
  delete exifObj.thumbnail;
  delete exifObj["1st"];
  const exifBytes = piexif.dump(exifObj);
  const newImageString = piexif.insert(exifBytes, imageString);
  return Buffer.from(newImageString, "binary");
}

/**
 * Rotate a Photo.
 *
 * A single rotation is always 90° clockwise.
 *
 * @param {number} index index of Photo to rotate
 */
const rotatePhoto = (index: number) => {
  let photo = _photos.value[index];
  let { rotate } = photo;

  // init rotate property if it doesn't exist
  if (rotate === undefined) {
    rotate = 0;
  }

  // Rotate by 90°, convert 360° to 0°
  rotate = (rotate + 90) % 360;

  // remove rotate property if we are back to 0°
  if (rotate) {
    photo.rotate = rotate;
  } else {
    delete photo.rotate;
  }

  // Update photos array
  _photos.value.splice(index, 1, photo);

  // Update vuex
  setCustomerDictionaryDeep({ path: path, data: _photos.value });
}

/**
 * Delete a Photo.
 *
 * Note this only removes the Photo reference from the data in Vuex.
 * It DOES NOT delete the actual file from file storage (e.g. from FTP/S3).
 *
 * @param {number} index Index of Photo to delete
 */
const deletePhoto = (index: number) => {
  actProperty.confirmPrompt().then(() => {
    // Update photos array
    // const index = this._photos.findIndex(x => x._uuid == photo._uuid);
    _photos.value.splice(index, 1);

    // Update Vuex
    setCustomerDictionaryDeep({ path: path, data: _photos.value })
      .then(() => toasted.success("Photo removed"))
      .catch((err: any) => actProperty.displayError(err));
  }).catch(e => {});
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["file-upload mt-2", { drag: isDragging.value }]),
    onDragover: _withModifiers(onDragOver, ["stop","prevent"]),
    onDragleave: _withModifiers(onDragLeave, ["stop","prevent"]),
    onDrop: _withModifiers(onDrop, ["stop","prevent"])
  }, [
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_photos.value, (photo, $index) => {
        return (_openBlock(), _createBlock(LogoComponent, {
          key: _unref(actProperty).hashObj(photo),
          photo: photo,
          galleryType: galleryType(),
          isLogo: true,
          target: _unref(target),
          onRotate: ($event: any) => (rotatePhoto($index)),
          onDelete: ($event: any) => (deletePhoto($index))
        }, null, 8, ["photo", "galleryType", "target", "onRotate", "onDelete"]))
      }), 128))
    ]),
    (_photos.value.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (uploadingCount.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _hoisted_4))
            : (_openBlock(), _createElementBlock("label", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  (_unref(buttontext))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(buttontext)), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _hoisted_9,
                        _createTextVNode(" Photo ")
                      ]))
                ]),
                _createElementVNode("input", {
                  type: "file",
                  accept: "image/jpeg",
                  multiple: "",
                  ref_key: "file",
                  ref: file,
                  onChange: onFileInputChange
                }, null, 544)
              ]))
        ]))
      : _createCommentVNode("", true)
  ], 34))
}
}

})